var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.01367,
    y: 0.573578,
    width: 12,
    height: 12,
    rx: 3.52941,
    transform: "rotate(45 9.01367 0.573578)",
    fill: "url(#paint0_linear_1_7730)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95286 11.5147V10.9773L9.37867 9.57958C9.51503 9.44188 9.62867 9.31955 9.71958 9.2126C9.81048 9.10565 9.87867 9.00204 9.92412 8.90177C9.96958 8.8015 9.9923 8.69455 9.9923 8.58092C9.9923 8.45124 9.96289 8.34027 9.90407 8.24803C9.84524 8.15445 9.76436 8.08225 9.66142 8.03145C9.55848 7.98065 9.4415 7.95525 9.31048 7.95525C9.17546 7.95525 9.05714 7.98332 8.95554 8.03947C8.85393 8.09428 8.77506 8.17249 8.71891 8.2741C8.66409 8.3757 8.63669 8.49669 8.63669 8.63707H7.9288C7.9288 8.37637 7.98829 8.14977 8.10728 7.95725C8.22626 7.76474 8.39003 7.61568 8.59859 7.51006C8.80848 7.40445 9.04912 7.35164 9.32051 7.35164C9.59591 7.35164 9.83789 7.40311 10.0464 7.50605C10.255 7.60899 10.4168 7.75003 10.5317 7.92918C10.6481 8.10832 10.7062 8.31287 10.7062 8.54281C10.7062 8.69656 10.6768 8.84763 10.618 8.99602C10.5591 9.14442 10.4555 9.30886 10.3071 9.48934C10.1601 9.66982 9.95353 9.8884 9.68749 10.1451L8.9796 10.865V10.8931H10.7684V11.5147H7.95286Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7730",
    x1: 15.0137,
    y1: 0.573578,
    x2: 15.0137,
    y2: 12.5736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A52FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.c7039833ec82b9dcb8816109be969db7.svg";
export { ForwardRef as ReactComponent };